import StyledResponsiveImg from 'components/ResponsiveImg/StyledResponsiveImg';

export const Image = StyledResponsiveImg<{
  className?: string;
  display?: string;
  left?: string;
  maxHeight?: string;
  maxWidth?: string;
  minHeight?: string;
  minWidth?: string;
  padTop?: string;
  position?: string;
  width?: string;
}>`
  width: ${props => (props.width ? props.width : '100%')};
  height: ${props => (props.height ? props.height : 'auto')};
  ${props => (props.minWidth ? `min-width: ${props.minWidth};` : '')}
  ${props => (props.minHeight ? `min-height: ${props.minHeight};` : '')}
  ${props => (props.maxHeight ? `max-height: ${props.maxHeight};` : '')}
  ${props => (props.maxWidth ? `max-width: ${props.maxWidth};` : '')}
  ${({ display }) => (display ? `display: ${display}` : '')};
  ${({ position }) => (position ? `position: ${position}` : '')};
  left: ${props => (props.left ? props.left : '0')};
`;
